import { device } from '@src/common/breakpoints';
import { LayoutColors } from '@src/core/theme';
import styled from 'styled-components';

export const Message = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;

  margin-bottom: 16px;
`;

export const Alert = styled.div`
  background-color: ${LayoutColors.warningDark};
  font-weight: bold;
  color: ${LayoutColors.whiteLight};
  width: 100%;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Wrapper = styled.article`
  width: 100%;
  pointer-events: all;
  overflow: hidden;
  max-width: 533px !important;
  margin: 0 auto;
  margin-top: 120px;
  background-color: white;
  padding: 24px;

  ${device.smallTablet} {
    border-radius: 8px;
  }
`;
